export class DevLogger implements IDevLogger {
  enabled = false;

  constructor(enabled?: boolean) {
    this.enabled = enabled || this.enabled;
  }

  i(...args: unknown[]): void {
    if (this.enabled) {
      console.group(
        '%c[CLAIMS_APP] Info',
        'background-color: green; color: white'
      );
      console.log(...args)
      console.groupEnd();
    }
  }

  e(...args: unknown[]): void {
    if (this.enabled) {
      console.group(
        '%c[CLAIMS_APP] Error',
        'background-color: red; color: white'
      );
      console.log(...args)
      console.groupEnd();
    }
  }

  t(...args: unknown[]): void {
    if (this.enabled) {
      console.group(
        '%c[CLAIMS_APP] Table',
        'background-color: green; color: white'
      );
      console.table(...args);
      console.groupEnd();
    }
  }
}

// Define the interface for the public methods of DevLogger
interface IDevLogger {
  enabled: boolean;
  i(...args: unknown[]): void;
  e(...args: unknown[]): void;
  t(...args: unknown[]): void;
}

// Initialize the dev logger
export const initDevLogger = (enabled: boolean) => {
  if (typeof window !== 'undefined') {
    if (enabled) {
      window.dev = new DevLogger(enabled);
    } else {
      window.dev = {
        enabled: false,
        i: () => { },
        e: () => { },
        t: () => { },
      } as IDevLogger;
    }
  }
};
